import ShutterbugEmailPinVerify from './ShutterbugEmailPinVerify';

export default ShutterbugEmailPinVerify;
